class NostoPDPCompleteLook extends window.BAO.CustomElement() {
  constructor() {
    super()

    this.elements = {
      rawData: this.querySelector(
        '[data-nosto-pdp-complete-look-el="nostoData"]',
      ),
      destination: this.querySelector(
        '[data-nosto-pdp-complete-look-el="desination"]',
      ),
    }
  }

  connectedCallback() {
    if (!this.elements.rawData) return

    this.elements.jsonData = JSON.parse(this.elements.rawData.textContent)

    const dataToConstructHTML = this.elements.jsonData
      .map(product => {
        return {
          nostoUrl: product.url,
          shopifyHandle: this.extractHandle(product.url),
        }
      })
      .filter(item => typeof item === 'object' && item !== null)
    this.fetchAllProducts(dataToConstructHTML)
  }

  async fetchAllProducts(dataToConstructHTML) {
    const fetchPromises = dataToConstructHTML.map(data =>
      this.createProductList(data),
    )

    const htmlList = await Promise.all(fetchPromises)

    htmlList.forEach(html => {
      this.elements.destination.insertAdjacentHTML('beforeEnd', html)
    })
  }

  async createProductList(data) {
    const html = await this.fetchSectionHTML(data)
    return html
  }

  async fetchSectionHTML(data) {
    let sectionUrl = `/products/${data.shopifyHandle}?section_id=${this.sectionId}`
    if (window.routes.root_url !== '/') {
      sectionUrl = `${window.routes.root_url}${sectionUrl}`
    }
    return await fetch(
      sectionUrl
    )
      .then(response => response.text())
      .then(responseText => {
        const innerHTML = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('.shopify-section').innerHTML
        return innerHTML
      })
  }

  extractHandle(url) {
    const pathname = new URL(url).pathname
    const productHandle = pathname.split('/').pop()

    return productHandle
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  get sectionId() {
    return 'pdp-complete-look-card'
  }
}

if (!customElements.get('nosto-pdp-complete-look')) {
  customElements.define('nosto-pdp-complete-look', NostoPDPCompleteLook)
}
